import { useQuery } from '@hooks/reactQuery';

import { getPortalMilestonesAssignees } from '@api/portalMilestones';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_MILESTONES_ASSIGNEES } from '@constants/queryKeys';

interface IUseQueryPortalMilestonesAssigneesReturned {
	portalMilestonesAssignees: TNameTitleValueLabel[];
	isLoadingPortalMilestonesAssignees: boolean;
}

export const useQueryPortalMilestonesAssignees = (projectId?: string): IUseQueryPortalMilestonesAssigneesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_MILESTONES_ASSIGNEES, projectId],
		queryFn: extractQueryParams(getPortalMilestonesAssignees),
		select: requestTypes => projectUsersFormatted(requestTypes),
		enabled: [!!projectId],
		...refetchOptions,
	});

	return {
		portalMilestonesAssignees: data || [],
		isLoadingPortalMilestonesAssignees: isLoading || isFetching,
	};
};
